import styles from "./Certificates.module.css";
import React from "react";
import uw_logo from "../../../../assets/images/uw_logo.png";
// import google_logo from "../../../../assets/images/google_logo.png";
// import ibm_logo from "../../../../assets/images/ibm_logo.png";
// import atlassian_logo from "../../../../assets/images/atlassian_logo.png";
// import stanford_logo from "../../../../assets/images/stanford_logo.png";

const Certificates = () => {
    const certificates = [
        { id: 0, title: "Machine Learning Foundations: A Case Study Approach", subtitle: "University of Washington | Coursera", img: uw_logo, href: "https://coursera.org/share/4a4c786e8baff4afe701a605dee004e9", date: "26 August 2022" },
    ];

    const c_items = certificates.map((c) => {
        return (
            <div className={`${styles.item} w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/2 xl:pr-10`} key={c.id}>
                <div className={styles.left}>
                    <div className={styles.image}><img src={c.img} alt={c.title} /></div>
                </div>
                <div className={styles.right}>
                    <div className={styles.title}>{c.title}</div>
                    <div className={styles.subtitle}>{c.subtitle}</div>
                    <div className={styles.bottom}>
                        <div className={styles.link}><a href={c.href} target="_blank" rel="noreferrer">View Certificate</a></div>
                        <div className={styles.date}>{c.date}</div>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <div>
            <div className={styles.list}>
                {c_items}
            </div>
        </div>
    );
};

export default Certificates;
